import { Translation } from "../translation.model";
import { NotificationType } from "../../constants/notification-type.enum";
import { NotificationOffsetUnit } from "../../constants/notification-offset-unit.enum";
import { NotificationTrigger } from "../../constants/notification-trigger.enum";

export class TrialNotificationTemplate {
  public id: string;
  public trialId: string;
  public diaryFormId: string;
  public name: string;
  public rule: string;
  public enabled: boolean;
  public emailNotificationEnabled: boolean;
  public appNotificationEnabled: boolean;
  public mandatoryNotification: boolean;
  public createdAt: Date;
  public updatedAt: Date;
  public translations: Translation[] = [];
  public notificationType: NotificationType;
  public offsetUnit: number;
  public offsetAmount: number;
  public afterEvent: boolean;
  public trigger: NotificationTrigger = NotificationTrigger.None;
  public ediaryMissedEntryCount: number;
  public expression: string;
  public expressions: TrialNotificationExpression[] = [];
  public logicalOperator: number;

  constructor(init?: Partial<TrialNotificationTemplate>) {
    Object.assign(this, init);

    if (init) {
      if (init.notificationType)
        this.notificationType = init.notificationType as NotificationType;

      if (init.offsetUnit)
        this.offsetUnit = init.offsetUnit as NotificationOffsetUnit;

      if (init && init.expression && init.expression.length > 0)
        this.expressions = JSON.parse(init.expression).map(e => new TrialNotificationExpression(e));
    }
  }
}

export class TrialNotificationExpression {
  public elementId: string;
  public operator: string;
  public value: string;

  constructor(init?: Partial<TrialNotificationExpression>) {
    Object.assign(this, init);
  }

  isValid() {
    return this.elementId && this.operator && this.value;
  }
}
